import "./App.css";
import { Route, Routes } from "react-router-dom";
import FinancialGoals from "./financialPages/financialGoals/FinancialGoals";
import AvatarCreation from "./financialPages/avatartCreation/AvatarCreation";
import FinancialGoalsFil from "./financialPagesFil/financialGoals/FinancialGoalsFil";
import AvatarCreationFil from "./financialPagesFil/avatartCreation/AvatarCreationFil";

function App() {
  return (
    <Routes>
      <Route path="/" element={<FinancialGoals />} />
      <Route path="/avatar/En" element={<AvatarCreation />} />
      <Route path="/Fil" element={<FinancialGoalsFil />} />
      <Route path="/avatar/Fil" element={<AvatarCreationFil />} />
    </Routes>
  );
}

export default App;
